import React, { useContext } from "react";
import { Icon } from "@/components/Icon";
import IconsEnum from "enums/icons";
import { CalculatorContext } from "./CalculatorContext";
import s from "./styles/CalculatorCustomStyles.module.css";
import * as gtag from "@/lib/gtag";

const CalculatorMonthSelector = ({ properties }) => {
  return (
    <div className="w-full">
      <RadioToolbar properties={properties} />
    </div>
  );
};

export const RadioToolbar = ({ properties }) => {
  const { setCalculatorParams, calculatorParams } =
    useContext(CalculatorContext);

  const activeProperties =
    calculatorParams.type === "leasing" ? properties[0] : properties[1];
  const handleChange = (value) => {
    setCalculatorParams((prevParams) => ({
      ...prevParams,
      term: value,
      contractualMileage: 10000 * (value / 12),
    }));

    gtag.event({
      event: "itemClick",
      itemClick: "term_change",
      duration: `${value || "Monate"}`,
    });
  };

  const renderRadioInput = (item) => (
    <div className="w-full  cursor-pointer" key={item.label}>
      <input
        type="radio"
        id={item.label}
        name={item.name}
        value={item.value}
        checked={calculatorParams.term === item.value}
        onChange={() => handleChange(item.value)}
      />
      <label
        htmlFor={item.label}
        className={` w-full lg:my-0 my-4 cursor-pointer  `}
      >
        <div className="flex items-center justify-center">
          {item.icon && (
            <Icon
              type={IconsEnum[item.icon]}
              className="w-8 h-8 text-orange-medium  mr-4"
            />
          )}
          <span className={`xxl:text-basetext-sm`}>{item.label}</span>
        </div>
      </label>
    </div>
  );

  return (
    <div className={`mb-8 mt-2`} key={Math.random()}>
      <div
        className={`${s.RadioToolbar} gap-x-6 !grid grid-cols-2 lg:grid-cols-4 lg:gap-y-6 xl:grid-cols-${activeProperties.length}`}
      >
        {activeProperties.map((item) => renderRadioInput(item))}
      </div>
    </div>
  );
};

export default CalculatorMonthSelector;
